import { render, staticRenderFns } from "./examinationEyesHome.vue?vue&type=template&id=2c999ad8&scoped=true&"
import script from "./examinationEyesHome.vue?vue&type=script&lang=js&"
export * from "./examinationEyesHome.vue?vue&type=script&lang=js&"
import style0 from "./examinationEyesHome.vue?vue&type=style&index=0&id=2c999ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c999ad8",
  null
  
)

export default component.exports